import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import { Button } from 'components/Button'
import { useScrollToTop } from 'hooks/useScrollToTop'
import { Icon } from 'components/Icon'
import beefBowl from '../../../../../../../../public/assets/product-v2/freeze-dried-box/beef-fresh-fd-bowl.webp'
import {
  QualityIngredientsRoot,
  QualityIngredientsContainer,
  Headline,
  ContentRow,
  ImageColumn,
  ImageWrapper,
  CopyColumn,
  ClaimsList,
  ClaimItem,
  ClaimText,
  ButtonRow,
} from './QualityIngredients.styles'

export const QualityIngredients = () => {
  const { t } = useTranslation()
  const scrollToTop = useScrollToTop()

  const claims = [
    t('products-v2:freeze-dried-raw-nuggets.intro-hero.claim-1'),
    t('products-v2:freeze-dried-raw-nuggets.intro-hero.claim-2'),
    t('products-v2:freeze-dried-raw-nuggets.intro-hero.claim-3'),
  ]

  return (
    <QualityIngredientsRoot>
      <QualityIngredientsContainer>
        <Headline>{t('products-v2:freeze-dried-raw-nuggets.intro-hero.headline')}</Headline>
        <ContentRow>
          <ImageColumn>
            <ImageWrapper>
             <Image
              src={beefBowl}
              alt={t('products-v2:freeze-dried-raw-nuggets.intro-hero.image')}
              priority
            /> 
            </ImageWrapper>
            
          </ImageColumn>
          <CopyColumn>
            <ClaimsList>
              {claims.map((claim, index) => (
                <ClaimItem key={index}>
                  <Icon name="checkbox-circle-line" size="4" color="primary-500" />
                  <ClaimText>{claim}</ClaimText>
                </ClaimItem>
              ))}
            </ClaimsList>
          </CopyColumn>
        </ContentRow>
        <ButtonRow>
          <Button className='cta' onClick={() => scrollToTop('smooth')}>{t('products-v2:freeze-dried-raw-nuggets.intro-hero.cta')}</Button>
        </ButtonRow>
      </QualityIngredientsContainer>
    </QualityIngredientsRoot>
  )
}

QualityIngredients.displayName = 'QualityIngredients'
